<template>
  <div class='tablePage'>
    <el-table v-loading='loading' ref='multipleTable' :data='tableData' tooltip-effect='dark'
              :header-cell-style='headCellStyle' :height='tableHeight' @selection-change='handleSelectionChange'>
      <el-table-column type='selection' width='50' />
      <el-table-column v-if='isSys' prop='scopeName' :label="$t('public.table_scope')" show-overflow-tooltip />
      <el-table-column prop='name' :label="$t('public.table_code')" show-overflow-tooltip>
        <template #default='{ row }'>
          <DeviceCode :device='row'>
            <template #icon='{device}'>
              <i v-icon:theme="['relayTypeConvert', device.type]" v-if='!$slots.icon'></i>
            </template>
            <template #name='{device}'>
              <el-popover placement='top-start' width='auto' trigger='hover'>
                <v-popoer :rowData='device' :typeWay='$attrs.sensorWay' />
                <span slot='reference' :class="{'bolder':device.status === ENUM_DEVICE_STATUS.OFFLINE}">
                           {{ device.relayCode }}
                        </span>
              </el-popover>
            </template>
          </DeviceCode>
        </template>
      </el-table-column>
      <el-table-column prop='carrierName' width='200' :label="$t('public.table_carrier')" show-overflow-tooltip>
        <template #default='{ row }'>
          <CardSwipper :list='[row]' :key='Math.random()'>
            <template #title='{item}'>
              {{ item.sceneName }}
            </template>
            <template #default='{item}'>
              <div class='uk-flex'>
                <div style='width: 30px' class='bd-r uk-flex uk-flex-center'>
                  <i class='uk-margin-remove'
                     @click='carrierDetailFn(row.carrierType, row.carrierId)'
                     v-icon="['carrierTypeConvert',row.carrierType]"></i>
                </div>
                <div class='uk-flex-1'>
                  {{ item.carrierName }}
                </div>
              </div>
            </template>
          </CardSwipper>
        </template>
      </el-table-column>

      <el-table-column prop='updateTime' :label="$t('public.update_time')" show-overflow-tooltip>
        <template #default='{row}'>
          {{ $timetransition(row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column prop='optare' fixed='right' :label="$t('public.table_operation')" width='120' align='right'>
        <template #default='{ row }'>
          <div style='text-align:center;white-space: nowrap;'>
            <el-button type='text' size='small' v-for='item in optareBtn' :key='item.id' :title='$t(item.title)'
                       :icon='item.icon' @click='handle(item.method, row)'></el-button>
            <!-- v-has="item.vHas" -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 监测点详情 -->
    <MonitorDialog :visible.sync='dialogVisible' :carrier-info='carrierDetail'></MonitorDialog>
  </div>
</template>
<script>
import prover from '../components/Proper.vue'
import { carrierDetail } from '@/api/modules/carrier.js'
import { carrierTypeConvert, configStatusConvert, equiStatusConvert, relayTypeConvert } from '@/utils/convert'
import { getIsSys } from '@/utils/permission'
import CardSwipper from '@/components/CardSwipper/CardSwipper.vue'
import MonitorDialog from '@/pages/equipment/publicCom/MonitorDialog.vue'
import DeviceCode from '@/pages/equipment/publicCom/DeviceCode.vue'
import { ENUM_DEVICE_STATUS } from '@/common/enum/forward/device'

export default {
  computed: {
    ENUM_DEVICE_STATUS () {
      return ENUM_DEVICE_STATUS
    }
  },
  props: ['loading', 'tableData'],
  components: {
    DeviceCode,
    CardSwipper,
    'v-popoer': prover,
    MonitorDialog
  },
  data () {
    return {
      relayTypeConvert,
      equiStatusConvert,
      configStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      optareBtn: [
        {
          id: 1,
          title: $t('public.stop'),
          icon: 'el-icon-video-pause',
          vHas: [],
          method: 'stopUseFn'
        },
        {
          id: 2,
          title: $t('public.config'),
          icon: 'el-icon-setting',
          vHas: [],
          method: 'configFn'
        },
        {
          id: 4,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        }
      ],
      isSys: true,
      isLoading: false,
      dialogVisible: false,
      carrierDetail: null
    }
  },
  created () {
    // this.getCarrierTypeFn()
  },
  mounted () {
    this.isSys = getIsSys()
  },
  methods: {
    /** 查找监测点详情 */
    carrierDetailFn (type, carrierId) {
      this.dialogVisible = true
      this.isLoading = true

      carrierDetail(type, carrierId)
        .then(({ result }) => {
          this.carrierDetail = result
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },

    handleCarrierFn (carrierName) {
      const array = carrierName.split('-')
      this.dialogVisible = true
      this.isLoading = true
      carrierDetail({ id: array[0] })
        .then(({ result }) => {
          this.carrierDetail = result
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    // carrierFn(carrierName) {
    //     console.log(carrierName);
    //     let array = carrierName.split('-');
    //     return array[2]
    // },
    handle (method, row) {
      this.$emit(method, row)
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang='scss' scoped>
.tablePage {
  height: calc(100% - 60px);
}
</style>
